/* src/app/account/digital-wallet/dw-dashboard/dw-dashboard.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
:host,
.dashboard,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.dashboard,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.dashboard {
  font-size: 1rem;
}
.dashboard .colum-layout {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 21px;
}
.dashboard .colum-layout .row-layout {
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: var(--semantic-colors-ups-success-green-light, #D4EEDD);
}
.dashboard .colum-layout .row-layout .text {
  color: var(--ups-brand-colors-ups-black, #121212);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.dashboard .colum-layout .row-layout .text-link {
  text-decoration-line: underline;
  cursor: pointer;
}
.dashboard .colum-layout .rectangle {
  width: 1179px;
  height: 288px;
  background: url("./media/upsc-dw-dashboard.png"), lightgray 50%/cover no-repeat;
}
.dashboard .giftBox {
  margin-top: 1em;
  width: 50px;
  height: 50px;
}
.dashboard .giftBox .giftIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--ups-brand-colors-ups-teal, #0A8080);
}
.dashboard .giftBox .giftIcon .ellipse16 {
  height: 50px;
  width: 50px;
}
.dashboard .giftBox .giftIcon .gift {
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  margin-left: -42.5px;
  margin-top: -3px;
}
.dashboard .giftBox .giftIcon h1 {
  display: flex;
  width: 131px;
  height: 15px;
  margin-top: -33px;
  margin-left: 53px;
  flex-direction: column;
  justify-content: center;
  color: #FFF;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Roboto Flex", sans-serif;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 10px;
}
.dashboard .giftBox .giftIcon .close {
  width: 10px;
  height: 9.959px;
  margin-top: -21px;
  margin-right: 14px;
  flex-shrink: 0;
}
.dashboard .giftBox .giftIcon.active {
  transition:
    width 0.5s ease-out,
    font-size 0.5s ease-out,
    line-height 1s ease-out,
    height 0.5s ease-out,
    transform 0.5s ease-out 1s;
  height: 50px;
  width: 218px;
  border-radius: 25px 25px 25px 25px;
}
.dashboard .dashboard-footer {
  display: none;
  margin-top: auto;
  padding: 0 1em 2em 1.5em;
}
@media screen and (min-width: 64rem) {
  .dashboard .dashboard-footer {
    display: none;
    font-size: 0.75em;
    color: #817b7b;
  }
}
.dashboard .banner-wrapper {
  position: relative;
}
.dashboard .banner-wrapper .banner-Panel {
  width: 100%;
  background: var(--capital-gradent-top-component, linear-gradient(351deg, #DCE8E7 26%, #F3F3F3 55.74%));
}
.dashboard .banner-wrapper .banner-Panel .panel {
  margin-top: 1em;
  height: 167px;
}
.dashboard .banner-wrapper .banner-Panel .panel .section {
  position: relative;
  margin-left: 7em;
}
.dashboard .banner-wrapper .banner-Panel .panel .section .image1 {
  width: 50.484px;
  height: 77px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dashboard .banner-wrapper .banner-Panel .panel .section .image1 .hero-large {
  position: relative;
  width: 281.484px;
  height: 281.513px;
  margin-top: 8em;
}
.dashboard .banner-wrapper .banner-Panel .panel .section .image2 {
  width: 350px;
  height: 200px;
  margin-left: 6.3em;
  position: relative;
}
.dashboard .banner-wrapper .banner-Panel .hero-small {
  width: 100%;
}
.dashboard upsc-notification-banner {
  margin-top: 1rem;
}
.dashboard upsc-notification-banner [icon] {
  width: 1.25rem;
  height: 1.25rem;
  margin-right: 0.75rem;
}
.dashboard upsc-notification-banner [icon] .material-icons {
  width: 1.25rem;
  height: 1.25rem;
  font-size: 1.25rem;
}
.dashboard upsc-notification-banner a {
  color: inherit;
  font-weight: 700;
  text-decoration: underline;
}
.dashboard upsc-notification-banner a:hover {
  color: inherit;
}
.dashboard .banner {
  height: 15.625rem;
  background-color: #e8e8e6;
  overflow: hidden;
}
.dashboard .banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.dashboard .banner img.hero-small {
  display: block;
}
@media screen and (min-width: 48rem) {
  .dashboard .banner img.hero-small {
    display: none;
  }
}
.dashboard .banner img.hero-large {
  display: none;
}
@media screen and (min-width: 48rem) {
  .dashboard .banner img.hero-large {
    display: block;
  }
}
.dashboard .dashboard-items-wrapper {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0 0.8125rem 0.8125rem;
}
@media screen and (min-width: 64rem) {
  .dashboard .dashboard-items-wrapper {
    padding: 0;
  }
}
@media screen and (min-width: 64rem) {
  .dashboard .dashboard-items-wrapper {
    flex-direction: row;
  }
}
.dashboard .dashboard-items-wrapper .main-items,
.dashboard .dashboard-items-wrapper .side-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.dashboard .dashboard-items-wrapper .main-items .dashboard-item,
.dashboard .dashboard-items-wrapper .side-items .dashboard-item {
  margin-top: 0.8125rem;
}
@media screen and (min-width: 64rem) {
  .dashboard .dashboard-items-wrapper .main-items {
    flex: 1 0 71.4285714286%;
    padding-right: 0.8125rem;
  }
}
.dashboard .dashboard-items-wrapper .main-items .dashboard-items {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .dashboard .dashboard-items-wrapper .main-items .dashboard-items {
    flex-direction: row;
  }
}
.dashboard .dashboard-items-wrapper .main-items .dashboard-items .dashboard-item-wrapper {
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .dashboard .dashboard-items-wrapper .main-items .dashboard-items .dashboard-item-wrapper:first-of-type {
    padding-right: 0.40625rem;
  }
  .dashboard .dashboard-items-wrapper .main-items .dashboard-items .dashboard-item-wrapper:last-of-type {
    padding-left: 0.40625rem;
  }
  .dashboard .dashboard-items-wrapper .main-items .dashboard-items .dashboard-item-wrapper:only-child {
    padding: 0;
  }
}
.dashboard .dashboard-items-wrapper .side-items {
  min-width: 21.9375rem;
}
@media screen and (min-width: 64rem) {
  .dashboard .dashboard-items-wrapper .side-items {
    flex: 1 0 28.5714285714%;
    min-width: 20.5rem;
  }
}
@media screen and (min-width: 48rem) and (max-width: 64rem) {
  .dashboard .dashboard-items-wrapper .side-items .dashboard-items {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: space-between;
  }
}
.dashboard .dashboard-items-wrapper .side-items .dashboard-items .dashboard-item-wrapper {
  flex: 1;
}
@media screen and (min-width: 48rem) and (max-width: 64rem) {
  .dashboard .dashboard-items-wrapper .side-items .dashboard-items .dashboard-item-wrapper:first-of-type {
    padding-right: 0.40625rem;
  }
  .dashboard .dashboard-items-wrapper .side-items .dashboard-items .dashboard-item-wrapper:last-of-type {
    padding-left: 0.40625rem;
  }
}
.dashboard .dashboard-items-wrapper .dashboard-item {
  border: solid thin #e8e8e6;
  border-radius: 5px;
  padding: 1em 1em 2em 1em;
  overflow-x: hidden;
  grid-row: auto;
  grid-column: auto;
  font-size: 1rem;
  box-shadow: 0 1px 2px 0 rgba(211, 211, 211, 0.5);
}
.dashboard .dashboard-items-wrapper .dashboard-item:not(.events),
.dashboard .dashboard-items-wrapper .dashboard-item:not(.news) {
  background-color: white;
}
.dashboard .dashboard-items-wrapper .dashboard-item .title,
.dashboard .dashboard-items-wrapper .dashboard-item .subtitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.dashboard .dashboard-items-wrapper .dashboard-item .title {
  font-size: 1em;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-transform: capitalize;
  font-weight: 700;
  min-height: 1em;
  height: 3.125em;
  margin: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item .title .icon {
  margin: 0 0.5em;
}
.dashboard .dashboard-items-wrapper .dashboard-item .title .icon:first-child {
  margin: 0 0.5em 0 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item .title .icon:last-child {
  margin: 0 0 0 0.5em;
}
.dashboard .dashboard-items-wrapper .dashboard-item p {
  font-size: 0.9em;
}
.dashboard .dashboard-items-wrapper .dashboard-item p.cta {
  font-size: 1.5em;
  font-weight: 700;
}
.dashboard .dashboard-items-wrapper .dashboard-item p.center {
  text-align: center;
}
.dashboard .dashboard-items-wrapper .dashboard-item .actions {
  margin-top: auto;
}
.dashboard .dashboard-items-wrapper .dashboard-item .actions a.mat-mdc-raised-button:hover {
  text-decoration: none;
}
.dashboard .dashboard-items-wrapper .dashboard-item .ups-form {
  margin-top: auto;
}
.dashboard .dashboard-items-wrapper .dashboard-item .form-footer {
  padding: 2em 0 0 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item .form-footer .form-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  margin-left: initial;
  width: 100%;
}
.dashboard .dashboard-items-wrapper .dashboard-item .form-footer .form-actions .mat-mdc-raised-button {
  width: 100%;
}
.dashboard .dashboard-items-wrapper .dashboard-item.announcement,
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track {
  height: auto;
}
.dashboard .dashboard-items-wrapper .dashboard-item.announcement {
  align-items: stretch;
}
.dashboard .dashboard-items-wrapper .dashboard-item.announcement .title {
  font-size: 1em;
  letter-spacing: 0.8px;
  margin: 0.625rem 0 0.9375rem;
  height: auto;
}
.dashboard .dashboard-items-wrapper .dashboard-item.announcement ::ng-deep p {
  font-size: 0.8125em;
  font-weight: 500;
  line-height: 1.77;
  padding: 0 2.125rem;
}
.dashboard .dashboard-items-wrapper .dashboard-item.sidebanner {
  display: none;
  background-color: white;
  padding: 0;
  height: 10.54375em;
  width: 20.43625em;
}
@media screen and (min-width: 48rem) {
  .dashboard .dashboard-items-wrapper .dashboard-item.sidebanner {
    display: block;
  }
}
.dashboard .dashboard-items-wrapper .dashboard-item.sidebanner img {
  height: 100%;
  width: 100%;
}
.dashboard .dashboard-items-wrapper .dashboard-item.events,
.dashboard .dashboard-items-wrapper .dashboard-item.news {
  padding: 0;
  background-color: #f4f4f4;
}
.dashboard .dashboard-items-wrapper .dashboard-item.events .title,
.dashboard .dashboard-items-wrapper .dashboard-item.news .title {
  margin: 0;
  min-height: 3.125em;
  line-height: 2.5;
  padding-top: 0.25em;
  background-color: white;
}
.dashboard .dashboard-items-wrapper .dashboard-item.events .title .icon,
.dashboard .dashboard-items-wrapper .dashboard-item.news .title .icon {
  margin-right: 0.78125em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.news .title {
  border-bottom: solid thin #e8e8e6;
}
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly !important;
  height: 13.75em;
  padding-bottom: 1em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups .title,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups p,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups .actions,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex .title,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex p,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex .actions {
  height: 2.8125em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups p,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex p {
  margin-bottom: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups .actions,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex .actions {
  margin-top: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.ship-ups .actions .mat-mdc-raised-button,
.dashboard .dashboard-items-wrapper .dashboard-item.ship-fedex .actions .mat-mdc-raised-button {
  font-size: 0.875rem;
  border: none;
  min-width: 12.5rem;
}
.dashboard .dashboard-items-wrapper .dashboard-item.restricted-zip,
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  padding: 0;
  height: auto;
}
.dashboard .dashboard-items-wrapper .dashboard-item.restricted-zip a,
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  font-size: 1em;
  font-weight: 500;
  width: 100%;
  height: 3.75em;
  overflow: hidden;
}
.dashboard .dashboard-items-wrapper .dashboard-item.restricted-zip a:hover,
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a:hover {
  text-decoration: none;
}
.dashboard .dashboard-items-wrapper .dashboard-item.restricted-zip a span,
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a span {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
}
.dashboard .dashboard-items-wrapper .dashboard-item.restricted-zip a .mat-icon,
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a .mat-icon {
  margin: 0 0.25em;
  font-size: 1.5em;
  line-height: 2.4;
  text-align: center;
}
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist {
  position: relative;
}
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a .mat-icon {
  position: relative;
  margin-top: -0.05em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.packaging-checklist a .mat-icon::after {
  content: "\e835";
  font-family: "Material Icons";
  position: absolute;
  top: 0.1em;
  left: -0.1em;
  font-size: 1em;
  line-height: inherit;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track {
  position: relative;
  padding: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track .see-all-tracks {
  position: absolute;
  font-size: 0.8125em;
  top: 1em;
  right: 1.5em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track .recipient {
  max-width: 12em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper {
  padding: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table {
  margin: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table th:first-of-type,
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table td:first-of-type {
  padding-left: 4.5%;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table th {
  padding: 0;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table td.tracking-number a {
  color: #009cbd;
  text-decoration: underline;
}
.dashboard .dashboard-items-wrapper .dashboard-item.quick-track ::ng-deep .dataTables_wrapper table td.status {
  color: #817b7b;
}
.dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  font-size: 1rem;
  padding: 1.15625em 0 1.5625em;
  height: 10.625em;
}
@media screen and (min-width: 48rem) {
  .dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 5em;
    padding: 0 1.875em 0 2.1875em;
  }
}
.dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator .title {
  font-size: 1em;
  height: auto;
  margin-bottom: 0.875em;
}
@media screen and (min-width: 48rem) {
  .dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator .title {
    height: 100%;
    margin-bottom: 0;
  }
}
.dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator .title .icon {
  margin-right: 1.875em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator p {
  font-size: 0.75em;
}
.dashboard .dashboard-items-wrapper .dashboard-item.cost-estimator .mat-mdc-raised-button {
  font-size: 0.875em;
  height: 2.8125rem;
  width: 9.375rem;
  line-height: 1;
}
/*# sourceMappingURL=dw-dashboard.component.css.map */
